module.exports = __webpack_public_path__ + "img/Logo-12.d13cf51f.svg";